import { useSetKam } from '@/hooks/buyers/useSetKam';
import { useGetKamList } from '@/hooks/staff/useGetKamList';
import { KamListResponseToSelectOptionListUi } from '@/hooks/staff/useGetKamList/mapper';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { AssignKamDialogUi, initialState } from './AssignKamDialogUi';

export function useAssignKamViewController() {
  const { buyerId } = useParams();
  const [uiState, setUiState] = useImmer<AssignKamDialogUi>(initialState);
  const getKamListHook = useGetKamList();
  const setKamHook = useSetKam();

  const onSelectKam = (kamId: string) =>
    setUiState((draft) => {
      draft.selectedKamId = kamId;
    });

  const onClickedSave = () => {
    if (!buyerId || !uiState.selectedKamId) return;
    setKamHook.mutate({ buyerId, kam_user_id: uiState.selectedKamId });
  };

  useEffect(() => {
    const kamList = getKamListHook.data?.data;
    if (!kamList) return;

    setUiState((draft) => {
      draft.kamList = KamListResponseToSelectOptionListUi(kamList);
    });
  }, [getKamListHook.data]);

  return {
    uiState: { ...uiState, saveDisabled: !uiState.selectedKamId },
    actions: { onSelectKam, onClickedSave },
  };
}
